import React, {useState} from 'react';
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import clsx from "clsx";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import {Divider, Paper} from "@mui/material";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import List from "@mui/material/List";
import EqualizerTwoToneIcon from '@mui/icons-material/EqualizerTwoTone';
import PieChartTwoToneIcon from '@mui/icons-material/PieChartTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import BlurLinearTwoToneIcon from '@mui/icons-material/BlurLinearTwoTone';
import LocalLibraryTwoToneIcon from '@mui/icons-material/LocalLibraryTwoTone';
import AddCircleTwoToneIcon from '@mui/icons-material/AddCircleTwoTone';
import TableChartTwoToneIcon from '@mui/icons-material/TableChartTwoTone';

const ReportDrawer = ({selected, setSelected}) => {
	const classes = BaseStyle();
	
	const [open, setOpen] = useState(true);
	
	const handleDrawerOpenClose = () => {
		setOpen(!open);
	};
	
	return (
        <React.Fragment>
            <Paper
				className={clsx(classes.drawer, classes.roundBorder, open ? classes.openDrawer : classes.closedDrawer)}>
				<div style={{display: "flex", justifyContent: "center"}}>
					<Tooltip title={open ? "Comprimi menù" : "Espandi menù"}>
						<IconButton onClick={handleDrawerOpenClose} size="large">
							{!open ? <ChevronRightIcon/> : <ChevronLeftIcon/>}
						</IconButton>
					</Tooltip>
				</div>
				<List>
					<ListItem button className={classes.roundBorder} selected={selected === "Ticket giorno - stato"}
					          onClick={() => setSelected("Ticket giorno - stato")}>
						<ListItemIcon>
							<EqualizerTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Ticket giorno - stato"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Ticket giorno"}*/}
					{/*          onClick={() => setSelected("Ticket giorno")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<TimelineTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Ticket giorno"}/>*/}
					{/*</ListItem>*/}
					<ListItem button className={classes.roundBorder} selected={selected === "Ticket stato"}
					          onClick={() => setSelected("Ticket stato")}>
						<ListItemIcon>
							<PieChartTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Ticket stato"}/>
					</ListItem>
					<ListItem button className={classes.roundBorder} selected={selected === "Ticket categoria"}
					          onClick={() => setSelected("Ticket categoria")}>
						<ListItemIcon>
							<LocalLibraryTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Ticket categoria"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Ticket ASL"}*/}
					{/*          onClick={() => setSelected("Ticket ASL")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<LocalConvenienceStoreTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Ticket ASL"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Ticket categoria - ASL"}*/}
					{/*          onClick={() => setSelected("Ticket categoria - ASL")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<DonutSmallTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Ticket categoria - ASL"}/>*/}
					{/*</ListItem>*/}
					<ListItem button className={classes.roundBorder} selected={selected === "Ticket categoria - giorno"}
					          onClick={() => setSelected("Ticket categoria - giorno")}>
						<ListItemIcon>
							<BlurLinearTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Ticket categoria - giorno"}/>
					</ListItem>
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Ticket ASL - giorno"}*/}
					{/*          onClick={() => setSelected("Ticket ASL - giorno")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<GestureTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Ticket ASL - giorno"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Utente"}*/}
					{/*          onClick={() => setSelected("Utente")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<StarsTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Utente"}/>*/}
					{/*</ListItem>*/}
				</List>
				<Divider/>
				<List>
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Quarantene giorno - stato"}*/}
					{/*          onClick={() => setSelected("Quarantene giorno - stato")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<DashboardTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Quarantene giorno"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Interviste giorno - stato"}*/}
					{/*          onClick={() => setSelected("Interviste giorno - stato")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<DescriptionTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Interviste giorno"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Monitoraggi score"}*/}
					{/*          onClick={() => setSelected("Monitoraggi score")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<ExposureTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Monitoraggi score"}/>*/}
					{/*</ListItem>*/}
					{/*<ListItem button className={classes.roundBorder} selected={selected === "Andamento positivi"}*/}
					{/*          onClick={() => setSelected("Andamento positivi")}>*/}
					{/*	<ListItemIcon>*/}
					{/*		<AddCircleTwoToneIcon/>*/}
					{/*	</ListItemIcon>*/}
					{/*	<ListItemText primary={"Andamento positivi"}/>*/}
					{/*</ListItem>*/}
				</List>
				{/*<Divider/>*/}
				{/*<List>*/}
				{/*	<ListItem button className={classes.roundBorder} selected={selected === "Vaccini giorno - tipo"}*/}
				{/*	          onClick={() => setSelected("Vaccini giorno - tipo")}>*/}
				{/*		<ListItemIcon>*/}
				{/*			<AssistantPhotoTwoToneIcon/>*/}
				{/*		</ListItemIcon>*/}
				{/*		<ListItemText primary={"Vaccini giorno - tipo"}/>*/}
				{/*	</ListItem>*/}
				{/*</List>*/}
				<Divider/>
				<List>
					<ListItem button className={classes.roundBorder} selected={selected === "Tabella riassuntiva"}
					          onClick={() => setSelected("Tabella riassuntiva")}>
						<ListItemIcon>
							<TableChartTwoToneIcon/>
						</ListItemIcon>
						<ListItemText primary={"Tabella riassuntiva"}/>
					</ListItem>
				</List>
			</Paper>
        </React.Fragment>
    );
};

export default React.memo(ReportDrawer)
